<template>
    <div>
        <a-page-header class="header"
                :breadcrumb="{ props: { routes, itemRender: itemRender } }"
                :title="courseInfo.name"
                :backIcon="false">
            <a-descriptions size="small" :column="5">
                <a-descriptions-item label="适用年龄">
                    {{courseInfo.minAge}} ~ {{courseInfo.maxAge}}
                </a-descriptions-item>
                <a-descriptions-item label="类型">
                    <span v-if="courseInfo.courseType === 1">测评课程</span>
                    <span v-if="courseInfo.courseType === 2">训练课程</span>
                </a-descriptions-item>
                <a-descriptions-item label="课时数">
                    {{ courseInfo.childCourseCount }}
                </a-descriptions-item>
            </a-descriptions>
        </a-page-header>
        <a-card>
            <a-form-model  class="search-form" layout="inline" :model="searchForm">
                <a-form-model-item label="用户查询">
                    <a-input :maxLength="30" allowClear v-model="searchForm.queryName" placeholder="请输入学生姓名或手机号"/>
                </a-form-model-item>
                <a-form-model-item label="解锁状态">
                    <a-select v-model="searchForm.status" allowClear placeholder="请选择测评名称">
                        <a-select-option :value="0">
                            未解锁
                        </a-select-option>
                        <a-select-option :value="1">
                            已解锁
                        </a-select-option>
                        <a-select-option :value="2">
                            已取消
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="领取时间">
                    <a-range-picker @change="pickerChange" v-model="time" :align="{points: ['tr']}" allowClear />
                </a-form-model-item>
                <a-form-model-item style="margin-right: 35px;">
                    <a-button @click="getPageList(1)" type="primary" html-type="button">
                        查询
                    </a-button>
                    <a-button @click="searchReset" style="margin-left: 10px;">
                        重置
                    </a-button>
                </a-form-model-item>
            </a-form-model>

            <a-table style="min-width: 800px;"
                     :columns="columns"
                     :rowKey="(text, index) => text.userId + '' + index"
                     :pagination="tableRelevant.tablePagination"
                     :loading="tableRelevant.tableLoading"
                     :dataSource="tableRelevant.tableDataSource">
                <div slot="mobile" slot-scope="text">
                    {{text.mobile}}&nbsp;
                    <a-tag v-if="text.channelName" color="blue">{{text.channelName}}</a-tag>
                    <a-tag v-else color="cyan">系列码</a-tag>
                </div>
                <div slot="userName" slot-scope="text">
                    {{text.userName ? text.userName : "--"}}
                </div>
                <div slot="status" slot-scope="text">
                    <span v-if="text.courseStatus === 2">已取消</span>
                    <span  v-if="text.courseStatus === 1">已解锁</span>
                    <span  v-if="text.courseStatus === 0">未解锁</span>
                </div>
            </a-table>
        </a-card>
    </div>
</template>

<script>
    import {tableRelevant} from "@/pages/projectImpl/js/utils";
    import $Bus from "@/pages/projectImpl/js/eventBus";

    const columns = [
        {
            title: '手机号',
            scopedSlots: {customRender: 'mobile'}
        },
        {
            title: '学生姓名',
            scopedSlots: {customRender: 'userName'}
        },
        {
            title: '解锁状态',
            scopedSlots: {customRender: 'status'}
        },
        {
            title: '领取时间',
            dataIndex: 'receiveTime'
        }
    ];

    export default {
        name: "LookCourseDetail",
        data() {
            return {
                routes: [
                    {
                        breadcrumbName: '首页',
                    },
                    {
                        breadcrumbName: '运营中心',
                    },
                    {
                        path: '/operate/ExperienceCourse',
                        breadcrumbName: '体验课配置',
                    },
                    {
                        breadcrumbName: '课程详情',
                    },
                ],
                courseInfo: this.$store.getters["operate/getCourseInfo"](),
                columns,
                time: undefined,
                searchForm: {
                    queryName: undefined,
                    status: undefined,
                    startTime: undefined,
                    endTime: undefined
                },
                //表格相关
                tableRelevant: tableRelevant.call(this),
            }
        },
        mounted() {
            $Bus.$emit("closePageHeader", true);
            this.getPageList(1);
        },
        methods: {
            itemRender({route, h}){
                const that = this;
                return h("span", route.path ? {
                        on: {
                            click: () => {
                                that.$router.push(route.path);
                            }
                        },
                        style: {
                            cursor: "pointer"
                        }
                    } : {}, route.breadcrumbName);
            },
            //获取能力体系列表
            getPageList(pageIndex) {
                const params = {
                    courseConfigId: this.courseInfo.id,
                    pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                    pageSize: this.tableRelevant.tablePagination.pageSize,
                    ...this.searchForm
                };
                this.tableRelevant.tableLoading = true;
                this.$http.Channel.getExperienceCoursePageList(params).then(res => {
                    this.tableRelevant.tableLoading = false;
                    const {data} = res.data;
                    this.tableRelevant.tableDataSource = data.items;
                    this.tableRelevant.tablePagination.total = data.totalCount;
                    this.tableRelevant.tablePagination.current = data.pageIndex;
                })
            },

            //重置
            searchReset() {
                for (let key in this.searchForm) {
                    this.searchForm[key] = undefined;
                }
                this.time = undefined;
                this.getPageList(1);
            },
            pickerChange(val){
                if (Array.isArray(val) && val.length){
                    this.searchForm.startTime = val[0].format('YYYY-MM-DD');
                    this.searchForm.endTime = val[1].format('YYYY-MM-DD');
                } else {
                    this.searchForm.startTime = undefined;
                    this.searchForm.endTime = undefined;
                }
            }
        },
        beforeDestroy(){
            $Bus.$emit("closePageHeader", false);
        }
    }
</script>

<style scoped>
    .header {
        width: 100%;
        border: 1px solid rgb(235, 237, 240);
        background-color: #fff;
        margin-bottom: 24px;
        box-sizing: content-box;
        margin-top: -24px;
        margin-left: -24px;
    }
</style>